export default "__VITE_ASSET__B64Vk4z1__"